import SuperFetch from '../../superFetch.js';

class BalanceApi {
  /**
   *  [정산 리스트] 정산 리스트 엑셀 다운로드
   */
  getBalanceListExcelDownload = (data) => SuperFetch.post('/balance/list/excel/download', data);

  /**
   *  [정산 리스트] 정산 아이템 리스트 엑셀 다운로드 요청하기
   */
  getBalanceItemListExcelDownload = (data) => SuperFetch.post('/balance/list/item/excel/download', data);

  /**
   *  [정산 상세] 정산 상세 가져오기
   */
  getBalanceDetail = (data) => SuperFetch.post('/balance/detail', data);

  /**
   *  [정산 상세] 정산 상세 수정하기
   */
  editBalanceDetail = (data) => SuperFetch.post('/balance/edit', data);

  /**
   *  [정산 브랜드 리스트] 정산 브랜드 리스트 가져오기
   */
  getBalanceBrandList = (data) => SuperFetch.post('/balance/brand/list', data);

  /**
   *  [정산 브랜드 리스트] 정산 브랜드 리스트 엑셀 다운로드
   */
  getBalanceBrandListExcelDownload = (data) => SuperFetch.post('/balance/brand/list/excel/download', data);
}

export default new BalanceApi();
